import React, { useState } from 'react'
import { CobuStack, CobuAlert } from '@cobu/ui'
import { useNavigate } from 'react-router-dom'
import PublicProfileLoading from '../../components/public-profile/PublicProfileLoading'
import PublicProfileError from '../../components/public-profile/PublicProfileError'
import PublicProfileCollapsingHeader, { HEADER_MAX_HEIGHT } from '../../components/public-profile/PublicProfileCollapsingHeader'
import PublicProfileModals from '../../components/public-profile/PublicProfileModals'
import PublicProfileContent from '../../components/public-profile/PublicProfileContent'
import { usePublicProfileScreen } from '../../hooks/usePublicProfileScreen'
import { Strings } from '../../constants/Strings'

// Temporary stubs until subcomponents are delivered
export const HEADER_MIN_HEIGHT = 84


export default function PublicProfileScreen() {
  const navigate = useNavigate()
  const [scrollY, setScrollY] = useState(0)

  const {
    showImageModal,
    showReportModal,
    showBlockConfirm,
    actionSheetRef,
    isOwnProfile,
    canMessage,
    canReport,
    profileData,
    currentUser,
    isLoading,
    error,
    handleManageProfile,
    handleMessage,
    handleMoreOptions,
    handleProfileImagePress,
    handleReportUser,
    handleCloseReportModal,
    handleReportSuccess,
    handleBlockUser,
    handleConfirmBlockUser,
    handleGroupPress,
    handleBackPress,
    setShowImageModal,
    setShowReportModal,
    setShowBlockConfirm,
    reportSuccessAlertOpen,
    setReportSuccessAlertOpen,
  } = usePublicProfileScreen()
  
  const strings = Strings.get()
  const viewUser: any = profileData?.user || currentUser
  const displayName = viewUser?.displayName || 'User'

  if (!isOwnProfile && isLoading) {
    return <PublicProfileLoading />
  }

  if (!viewUser || (!isOwnProfile && (!profileData || error))) {
    return <PublicProfileError />
  }

  const groups = profileData?.groups
  const sharedGroups = profileData?.sharedGroups

  return (
    <CobuStack f={1} bg="$backgroundSecondary" position="relative">
      <PublicProfileCollapsingHeader
        user={viewUser}
        currentUser={currentUser}
        scrollY={scrollY}
        onBackPress={handleBackPress}
        onProfileImagePress={handleProfileImagePress}
      />

      <div
        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflowY: 'auto' }}
        onScroll={(e) => setScrollY(e.currentTarget.scrollTop)}
      >
        <div style={{ paddingTop: HEADER_MAX_HEIGHT - 40 }}>
          <PublicProfileContent
            user={viewUser}
            currentUser={currentUser}
            groups={groups || []}
            sharedGroups={sharedGroups || []}
            isOwnProfile={isOwnProfile}
          canMessage={canMessage}
            onGroupPress={handleGroupPress}
            onManageProfile={handleManageProfile}
          onMessage={canMessage ? handleMessage : undefined}
            onMoreOptions={handleMoreOptions}
            onProfileImagePress={handleProfileImagePress}
          />
        </div>
      </div>

      <PublicProfileModals
        showImageModal={showImageModal}
        showReportModal={showReportModal}
        user={viewUser}
        currentUser={currentUser}
        actionSheetRef={actionSheetRef}
        isOwnProfile={isOwnProfile}
        imageUrl={viewUser?.profileImage}
        onCloseImageModal={() => setShowImageModal(false)}
        onCloseReportModal={handleCloseReportModal}
        onReportUser={handleReportUser}
        onReportSuccess={handleReportSuccess}
        onBlockUser={handleBlockUser}
        canReport={canReport}
      />
      
      {/* Block confirmation alert */}
      <CobuAlert
        open={showBlockConfirm}
        onOpenChange={setShowBlockConfirm}
        title={strings.discussion.commentActions.blockConfirm.title.replace('{displayName}', displayName)}
        description={strings.discussion.commentActions.blockConfirm.message}
        acceptText={strings.discussion.commentActions.labels.blockUser}
        cancelText={strings.discussion.commentActions.labels.cancel}
        onAccept={handleConfirmBlockUser}
        onCancel={() => setShowBlockConfirm(false)}
      />
      
      {/* Report success alert */}
      <CobuAlert
        open={reportSuccessAlertOpen}
        onOpenChange={setReportSuccessAlertOpen}
        title={strings.ui.reportUser.userReported}
        description={strings.ui.reportUser.userReportedMessage}
        onAccept={() => {
          setReportSuccessAlertOpen(false)
        }}
      />
    </CobuStack>
  )
}


